import styled from '@emotion/styled';
import {
  fallbackImage,
  fallbackText,
  getDataFromLink,
  Prismic,
  PrismicLink,
} from '@landsbankinn/prismic';
import { Segment, useMedia } from '@landsbankinn/ui';
import React, { forwardRef, useRef } from 'react';
import { CardGroup } from '../components/card-group/CardGroup';
import { AukakronurCard } from '../components/card/AukakronurCard';
import { Card } from '../components/card/Card';

interface IField {
  link: Prismic.Link;
  title: Prismic.RichText;
  color: Prismic.RichText;
  image: Prismic.Image;
}

interface IProps {
  fields: IField[];
}

const CardItem = forwardRef(function CardItem(
  { image, title, link, color, ...rest }: IField,
  ref,
) {
  const linkdata = getDataFromLink(link);
  const titled = Prismic.text(title);
  const imageRef = useRef();

  return (
    <Card
      link={link}
      imageRef={imageRef}
      title={
        link ? (
          <PrismicLink value={link} title={titled ?? undefined}>
            <a>{titled}</a>
          </PrismicLink>
        ) : (
          titled
        )
      }
      description={undefined}
      image={fallbackImage(image, linkdata.image ?? undefined)}
      ar={'ar_4_3'}
      percentage={2}
      padding={false}
      notLink={!link}
      backgroundColor={Prismic.text(color) ?? undefined}
      {...rest}
    />
  );
});

const CardImageSize = styled(CardItem)`
  img {
    width: 75% !important;
    height: 75% !important;
    min-height: 0 !important;
    max-width: 0 !important;
    object-fit: contain !important;
  }
`;

export const AukakronurCardsContainer = ({ fields }: IProps) => {
  const count = fields.length;
  const colSize = count <= 2 || count === 4 ? 2 : 3;
  const isMobile = useMedia('sm');

  return (
    <Segment paddingBottomMobile={0}>
      <CardGroup columns={colSize}>
        {fields?.map((item: any, index: any) => (
          <>
            {!isMobile && (
              <CardImageSize
                key={`product-item-${index}`}
                {...item}
                count={count}
              />
            )}
            {isMobile && (
              <AukakronurCard
                title={fallbackText(
                  item.title,
                  getDataFromLink(item.link).title ?? undefined,
                )}
                backgroundColor={item.color}
                key={`product-item-${index}`}
                {...item}
              ></AukakronurCard>
            )}
          </>
        ))}
      </CardGroup>
    </Segment>
  );
};
